import { Box, Grid } from "@mui/material";
import React, { useEffect } from "react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
// import Avatar from '@mui/material/Avatar';
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getApplicantHistory,
  getApplicationStatusHistory,
  getAppliedJobById,
  getAppliedJobs,
  getInterviewRounds,
  getOfferLetter,
} from "../../../Redux/Reducers/JobReducer";
import JobDescriptionSidebarApplicant from "./JobDescriptionSidebarApplicant";
import ApplicantInterviewRounds from "./SideFeedComponents/ApplicantInterviewRounds";
import AppliedJobsCompo from "./SideFeedComponents/AppliedJobsCompo";
import MyVisitingCard from "./SideFeedComponents/MyVisitingCard";
import RecommendedJobsCompo from "./SideFeedComponents/RecommendedJobsCompo";
import ApplicantOfferLetter from "./SideFeedComponents/ApplicantOfferLetter";
import SingleJobDescription from "./SideFeedComponents/SingleJobDescription";

const ApplicantSinglePage = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const selectedJob = useSelector((state) => state?.jobs?.singleAppliedJob);

  // console.log("SelectedJobApplicantSinglePage", selectedJob, id);

  //  await dispatch(getAppliedJobById(job?.job_id));
  useEffect(() => {
    fetchAPI()
  }, [id]);

  async function fetchAPI() {
    const res = await dispatch(getAppliedJobById(id));
    if (res?.payload?.status == 200) {
      const jobData = res?.payload?.data?.job;
      // console.log("jobDataInApplicantSinglePage", jobData);
      if (jobData?.application_status?.includes("Offer")) {
        await dispatch(getOfferLetter(jobData?.id));
      } else if (jobData?.application_status == "Interview In-Progress" || jobData?.application_status == "Selected") {
        await dispatch(getInterviewRounds(jobData?.id));
      }
      await dispatch(getAppliedJobs());
      await dispatch(getApplicantHistory());
      await dispatch(getApplicationStatusHistory({ id: jobData?.id }));
    }

  }

  return (
    <Box
      sx={{
        width: "100%",
        padding: 2,
        display: "flex",
        flexDirection: "row",
        gap: "20px",
        backgroundColor: "rgba(244, 247, 254, 1)",

      }}
    >
      {/* <Box sx={{ width: "30%" }}>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              width: "100%",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              margin: "auto",
            }}
          >
            <MyVisitingCard />
          </Box>
        </Grid>
        <Grid item xs={12} md={6} mt={5}>
          <AppliedJobsCompo />
        </Grid>
      </Box> */}
      <Box sx={{ width: "100%" }}>
        {/* <JobDescriptionSidebarApplicant /> */}
        <SingleJobDescription />
      </Box>

      {/* <Box sx={{ width: "30%" }}>{getSideBar()}</Box> */}
    </Box>
  );
};

export default ApplicantSinglePage;
